/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class IndividualCostOutput extends models.ViolationBase {
    getFixupPrototypeFunction() { return IndividualCostOutput.fixupPrototype; }

    static newInstance(model: Partial<IndividualCostOutput>): IndividualCostOutput {
        let obj = Object.assign(new IndividualCostOutput(), model);
        IndividualCostOutput.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<IndividualCostOutput>): IndividualCostOutput {
        if (!model) return null;
        return IndividualCostOutput.newInstance(<IndividualCostOutput> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: IndividualCostOutput) {
        if (!obj) return;

        models.IndividualCostOutput.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: IndividualCostOutput): boolean {
        if (models.ViolationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, IndividualCostOutput.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.cost === undefined) {
            this.cost = 0;
        }
        if (this.quantity === undefined) {
            this.quantity = 0;
        }
    }

    /**
     * Predicted cost of the resource.
     */
    cost: number;

    /**
     * The unit of the resource.
     */
    unit_of_measure: string;

    /**
     * Value for the attribute with which the cost prediction happens.
     */
    attributes: string;

    /**
     * The quantity of the resource.
     */
    quantity: number;

}
